<template>
    <div class="mediver-register-container nb">
        <div class="mediver-login-logo">
            <img src="@/assets/resource/icon/hover_logo.png" alt="Electroceuticals" class="login-logo-img" />
            <div class="sub-title">비밀번호 찾기</div>
        </div>
        <form class="register-box" @submit.prevent="findPassword">
            <div class="register-text">가입되어 있는 이메일 주소를 입력해 주세요.</div>
            <div class="find-row">
                <label class="find-label" for="email">이메일</label>
                <input id="email" type="email" class="find-input" v-model="email" placeholder="이메일" autocomplete="email" maxlength="200" @keydown.space.prevent/>
            </div>
            <div class="popup-btn-group">
                <button type="submit" class="blue-btn">비밀번호 찾기</button>
            </div>
            <div class="login-links">
                <span class="link" @click="$emit('toLogin')">로그인 화면</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toFindId')">아이디 찾기</span>
                <span class="divider">|</span>
                <span class="link" @click="$emit('toRegister')">회원가입</span>
            </div>
        </form>
    </div>
</template>
<script>
    import api, {urls} from '@/api'
    import { useAppAlert }  from '@/composables/useAppAlert';

    const { showAlert, showAlertAndMove, confirm } = useAppAlert()

    export default {
        name: "Password",
        data() {
            return {
                email: ""
            };
        },
        methods: {
            async findPassword() {
                if (!this.email) {
                    showAlert("이메일을 입력해주세요.");
                    return;
                }
                api.post(urls.login.findPassword, {
                    email: this.email
                }).then(response => {
                    const res = response.data;

                    if(res.error){
                        const result = res.error || '임시비밀번호 발급 중 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.';
                        showAlert(result)
                    }else{
                        showAlert('임시비밀번호를 발급하였으니 다시 로그인해주시길 바랍니다.')
                        this.$emit('status', this.email)
                    }
                }).catch(err => {
                    showAlert('임시비밀번호 발급 중 오류가 발생했습니다. 관리자에게 문의해주시길 바랍니다.')
                });
            }
        }
    };
</script>

